module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }